import React from 'react'
import useBrands from './customHooks/useBrands'
import { BrandHotelsMenu } from './brandsMenu'
import BrandsContentComponent from './BrandsContentComponent'
import './styles.scss'

export default function HotelBrands() {
  const { currentBrand, mainContent, selectNewCurrentBrand } = useBrands()

  return (
    <div className="HotelBrandsModule">
      <div className="main-module-container">
        <BrandHotelsMenu
          options={mainContent?.brands_title_list}
          currentBrand={currentBrand?.id}
          selectNewCurrentBrand={selectNewCurrentBrand}
        />
        <hr />
        <BrandsContentComponent list={mainContent.brands_body_list} current={currentBrand?.id} />
      </div>
    </div>
  )
}
